import CommiteeDecisionForm from './CommitteeDecisionForm';

const RevertCommitteeDecision = ({ offerID, step, status }) => {
  return (
    <CommiteeDecisionForm
      offerID={offerID}
      step={step}
      status={status}
    />
  );
};

export default RevertCommitteeDecision;
